import { environment } from "src/environments/environment";
import { OpenAPI } from "../surveyx-proxy";

export default function registerOpenAPI(): void {
    OpenAPI.BASE = environment.endPoint;
}